export default __webpack_public_path__ + "static/media/640_portfolio03-en-web.a0583784.png";